const createFadeAnimation = (duration, prop, inAnimation, outAnimation) => ({
    enter: {
        property: {
            name: prop,
            value: outAnimation,
        },
    },
    enterActive: {
        property: {
            name: prop,
            value: inAnimation,
        },
        transition: {
            duration,
            timing: 'ease',
        },
    },
    exit: {
        property: {
            name: prop,
            value: inAnimation,
        },
    },
    exitActive: {
        property: {
            name: prop,
            value: outAnimation,
        },
        transition: {
            duration,
            timing: 'ease-out',
        },
    },
});
const DrawerFadeIn = '1';
const DrawerFadeOut = '0';
const FadeAnimation = (duration) => createFadeAnimation(duration, 'opacity', DrawerFadeIn, DrawerFadeOut);

export { DrawerFadeIn, DrawerFadeOut, FadeAnimation };
//# sourceMappingURL=FadeAnimation.js.map
